export default {
  countries: []
}



// WEBPACK FOOTER //
// ./src/modules/countries/state.js